<p-dialog
  [header]="title"
  [modal]="modal"
  [(visible)]="visible"
  [closable]="false"
  [style]="{ width: '40rem' }"
>
  <div class="modal-body" style="max-height: 60vh; overflow-y: auto">
    <div class="row" [formGroup]="form">
      <div class="row">
        <div class="col-xl-12 mb-1">
          <label for="description" class="form-label"
            >{{ "definition.region.description" | translate }}<span class="text-danger"
              >*</span
            ></label
          >
          <textarea
            class="form-control"
            id="description"
            formControlName="description"
            rows="3"
            [placeholder]="
            'definition.region.placeholder.description'
              | translate
          "
          ></textarea>

          <div
            *ngIf="
            form.get('description')?.hasError('required') &&
            form.get('description')?.touched
          "
            class="text-danger"
          >
            <small *ngIf="form.get('description')?.errors?.['required']"
              >{{ "validation.required" | translate }}</small
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      style="margin-right: 3%"
      (click)="closeDialog()"
    >
      {{ "common.cancel" | translate }}
    </button>
    <button type="button" class="btn btn-success" (click)="onSave()">
      {{ "common.save" | translate }}
    </button>
  </div>
</p-dialog>
